import React from 'react';
import { QueryClientProvider, QueryClient } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { QUERY_TIME } from '../adapters/constants';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      staleTime: QUERY_TIME.TEN_MINUTES,
      cacheTime: 0,
      retry: 1,
    },
  },
});

const QueryProvider = ({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element => (
  <QueryClientProvider client={queryClient}>
    {children}
    <ReactQueryDevtools />
  </QueryClientProvider>
);

export default QueryProvider;
